// eslint-disable-next-line import-x/no-named-as-default
import Swiper from 'swiper/bundle';
import $ from 'jquery';

/* Carousel villas */
const slidesCount = document.querySelectorAll('.villas-swiper .swiper-slide').length;

new Swiper('.villas-swiper', {
  slidesPerView: 1.2,
  spaceBetween: 0,
  centeredSlides: false,
  navigation: {
    nextEl: '.next-villas',
    prevEl: '.prev-villas',
  },
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
  breakpoints: {
    520: {
      slidesPerView: slidesCount < 4 ? 'auto' : 2.2,
    },
    768: {
      slidesPerView: slidesCount < 4 ? 2 : 3.2,
    },
  },
});


/* Carousel bloc 'slider' */
var carousel_swiper = $('.carousel-swiper');
carousel_swiper.each( (index, carousel) => {
  var carousel_id = carousel.getAttribute('id');

  new Swiper('#'+carousel_id, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    slidesOffsetAfter: 16,
    navigation: {
      nextEl: '.next-'+carousel_id ,
      prevEl: '.prev-'+carousel_id,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      520: {
        slidesPerView: 2.2,
      },
      768: {
        slidesPerView: 3.2,
      },
    },
  });
});

/* Carousel membres de l'équipe */
new Swiper('.members-swiper', {
  slidesPerView: 1,
  spaceBetween: 32,
  centeredSlides: false,
  grabCursor: true,
  navigation: {
    nextEl: '.next-members',
    prevEl: '.prev-members',
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    768: {
      slidesPerView: 1.2,
    },
    992: {
      slidesPerView: 2.2,
      spaceBetween: 48,
    },
    1200: {
      slidesPerView: 2.5,
    },
  },
});

